module.exports = "/static/assets/169f7755a820bb597640f838ccc34af6.png";